import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { TechSpecsContent } from '@/app/[locale]/product/_types/carouselTypes';

interface SlideshowOR4TechSpecsContentProps extends TechSpecsContent {
  readonly showDiscount: boolean;
}

const SlideshowOR4TechSpecsContent = ({
  showDiscount,
  title,
  list,
}: SlideshowOR4TechSpecsContentProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div
      className={cx('relative mx-2', {
        'top-24 md:top-28 lg:top-32': showDiscount,
        'top-12 md:top-16 lg:top-20': !showDiscount,
      })}
    >
      <TypographyV3
        className="mb-2 text-body-lg text-white md:mb-4 md:text-heading-xl"
        color="unset"
        variant="unset"
        align="center"
        weight="normal"
        Element="div"
      >
        {t(title)}
      </TypographyV3>
      <div className="flex justify-center">
        {list?.map(({ icon: Icon, heading }, idx) => (
          <div
            key={idx}
            className="flex w-1/5 flex-col items-center text-white lg:w-1/4"
          >
            <div className="mb-1 md:hidden">
              <Icon width={25} height={25} />
            </div>
            <div className="mb-1 hidden md:block">
              <Icon width={42} height={42} />
            </div>
            <TypographyV3
              className="text-[8px] md:text-base"
              color="inherit"
              variant="unset"
              align="center"
              weight="normal"
              height="tight"
              Element="div"
            >
              {t.rich(heading)}
            </TypographyV3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SlideshowOR4TechSpecsContent;
